module.exports = __webpack_public_path__ + "img/icon-instagram.996b697c.svg";